import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { trackTeamMemberView } from '../utils/analytics';
import { ensureSecureUrl } from '../utils/urlHelper';
import AuthContext from '../context/AuthContext';

const TeamCard = ({ image, name, description, member }) => {
  const navigate = useNavigate();
  const { getAssetUrl, PUBLIC_API_URL, API_URL } = useContext(AuthContext);

  const handleClick = () => {
    trackTeamMemberView(name);
    // Fire and forget view tracking
    try {
      const baseUrl = PUBLIC_API_URL || API_URL || '/api';
      axios.post(`${baseUrl}/team/${member?._id || encodeURIComponent(name)}/view`);
    } catch (e) {
      // Ignore errors for analytics
    }
    navigate(`/t/${member?._id || name}`);
  };

  // Priority: 1. Profile Photo, 2. Avatar, 3. Passed image prop
  const profilePhoto = typeof member?.profilePhoto === 'string'
    ? member.profilePhoto
    : (member?.profilePhoto?.url || (member?.photos && (typeof member.photos[0] === 'string' ? member.photos[0] : member.photos[0]?.url)));
  const avatarUrl = member?.avatarConfig?.modelUrl;
  const rawImage = profilePhoto || avatarUrl || (typeof image === 'string' ? image : (image?.url || ''));
  const displayImage = rawImage ? ensureSecureUrl(getAssetUrl(rawImage, { width: 180, quality: 75 })) : undefined;

  return (
    <div
      onClick={handleClick}
      className="md3-card-elevated cursor-pointer group w-full max-w-[320px] mx-auto h-full min-h-[380px] flex flex-col relative"
    >
      <div className="p-5 flex flex-col items-center flex-grow">
        {/* Profile Image */}
        <div className="mb-4 flex justify-center">
          <img
            src={displayImage}
            alt={name}
            loading="lazy"
            width="144"
            height="144"
            className="w-32 h-32 sm:w-36 sm:h-36 rounded-full object-cover shadow-elevation-1 group-hover:shadow-elevation-2 transition-shadow duration-medium2 ease-standard bg-surface-container"
          />
        </div>

        {/* Content */}
        <div className="text-center w-full">
          <h3 className="text-title-large font-semibold text-surface-on mb-1">
            {name}
          </h3>

          {member?.age && (
            <p className="text-label-medium text-secondary mb-2">
              {member.age} Jahre alt
            </p>
          )}

          {member?.job && (
            <p className="text-label-large font-medium text-primary mb-2">
              {member.job}
            </p>
          )}

          <p className="text-body-small text-surface-onVariant mt-2 leading-relaxed line-clamp-3">
            {member?.shortDescription || description}
          </p>
        </div>
      </div>

      {/* State layer for hover effect */}
      <div className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-[0.08] transition-opacity duration-short4 ease-standard pointer-events-none rounded-xl" />
    </div>
  );
};

export default TeamCard;

